import * as React from 'react';
var getUniqueId = function () {
  var index = 1;
  return function () {
    return "control__".concat(index++);
  };
}();
var useId = 'useId';
var maybeReactUseId = React["".concat(useId)];
var useCustomUniqueId = function useCustomUniqueId() {
  return React.useMemo(getUniqueId, []);
};
var useUniqueId = maybeReactUseId !== undefined ? function () {
  return "control__".concat(maybeReactUseId());
} : useCustomUniqueId;
export default useUniqueId;